const BASE = '/plus-websites/onboarding';

export const ONBOARDING_SEGMENTS = {
  steps: 'steps',
  colour: 'colour',
  logo: 'logo',
  preview: 'preview',
  homepage: 'homepage',
  domain: 'domain',
  success: 'success',
} as const;

export type OnboardingSegment = (typeof ONBOARDING_SEGMENTS)[keyof typeof ONBOARDING_SEGMENTS];

export const ONBOARDING_PATHS = {
  base: BASE,
  steps: `${BASE}/${ONBOARDING_SEGMENTS.steps}`,
  colour: `${BASE}/${ONBOARDING_SEGMENTS.colour}`,
  logo: `${BASE}/${ONBOARDING_SEGMENTS.logo}`,
  preview: `${BASE}/${ONBOARDING_SEGMENTS.preview}`,
  homepage: `${BASE}/${ONBOARDING_SEGMENTS.homepage}`,
  domain: `${BASE}/${ONBOARDING_SEGMENTS.domain}`,
  success: `${BASE}/${ONBOARDING_SEGMENTS.success}`,
} as const;
